import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Flame } from "lucide-react";

/**
 * Tiny admin-only card on the Settings tab to flip Smack Stream on/off for
 * this league. Default is ON. iter31m, Phase 1.
 */
export default function SmackStreamAdminToggleCard({ league, leagueId, isLocked, onChanged }) {
    // Default to ON if the field is undefined (back-compat with leagues created before iter31m).
    const initial = league?.smack_stream_enabled !== false;
    const [enabled, setEnabled] = useState(initial);
    const [busy, setBusy] = useState(false);

    const flip = async () => {
        const next = !enabled;
        setBusy(true);
        try {
            await api.toggleSmackStream(leagueId, next);
            setEnabled(next);
            toast.success(next ? "Smack Stream enabled" : "Smack Stream hidden");
            onChanged?.();
        } catch (err) {
            toast.error(err.response?.data?.detail || "Toggle failed");
        }
        setBusy(false);
    };

    return (
        <div
            data-testid="smack-stream-admin-toggle-card"
            className={`brutal-card p-5 flex flex-wrap items-center justify-between gap-3 ${enabled ? "border-heat/40" : ""}`}
        >
            <div className="flex items-start gap-3 min-w-0">
                <Flame className="w-5 h-5 text-heat shrink-0 mt-0.5" />
                <div className="min-w-0">
                    <h2 className="font-display font-extrabold text-xl uppercase">Smack Stream</h2>
                    <p className="text-xs text-zinc-400 mt-1 leading-relaxed">
                        Lightweight trash-talk wall for your players (128-char posts, 5 every 30 min). Hide it here if your rivalry wants a cleaner dashboard.
                    </p>
                </div>
            </div>
            <button
                data-testid="smack-stream-admin-toggle-btn"
                onClick={flip}
                disabled={busy || isLocked}
                className={`brutal-btn text-xs py-2 ${enabled ? "bg-heat text-white" : "bg-transparent text-white border-[#333] shadow-none"} disabled:opacity-50`}
            >
                {busy ? "Saving..." : enabled ? "Visible — click to hide" : "Hidden — click to show"}
            </button>
        </div>
    );
}
